// 将jQuery的文档加载事件改为原生JS
document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("pq-member-tasks")) {
    customElements.define(
      "pq-member-tasks",
      class MemberTasks extends HTMLElement {
        constructor() {
          super();
          this.container = null;
        }

        connectedCallback() {
          this.initTasks();
        }

        // 获取任务列表
        async getMemberRedeem(data) {
          const url = "/shopify/point-task/page";
          const res = await window.pq.http.get(url, {
            data,
          });
          if (res.code === 200) {
            return res.data;
          } else {
            throw new Error(window.i18n.error_message_timeout);
          }
        }

        async completePointTask(id) {
          const url = `/shopify/user/point/task/${id}`;
          const res = await window.pq.http.post(url);
          if (res.code === 200) {
            return res.data;
          } else {
            throw new Error(window.i18n.error_message_timeout);
          }
        }

        async doTask(id, taskType, url = "") {
          switch (taskType) {
            case 1:
              window.pq.openAccountDrawer("login-register", "register");
              break;
            case 2:
              const footer = document.querySelector("main-footer");
              if (footer) {
                const input = footer.querySelector(
                  'input[name="contact[email]"]'
                );
                if (input) input.focus();
              }
              break;
            case 3:
              window.location.href = "/account?type=profile";
              break;
            case 4:
              window.location.href = "/";
              break;
            case 5:
              window.location.href = "/pages/register-warranty";
              break;
            case 6:
              window.location.href = "/pages/avis-power-queen-batterie-lithium";
              break;
            default:
              if (url) {
                try {
                  const res = await this.completePointTask(id);
                  if (isCompleted) {
                    this.hasTaskCompleted(id);
                  }
                  window.pq.eventBus.publish("CHANGE_USER_POINTS_DATA", res);
                } catch (error) {
                  // 忽略错误
                }

                let openUrl = url;
                if (taskType == 11) {
                  openUrl = `https://www.instagram.com/share?url=${encodeURIComponent(
                    url
                  )}`;
                } else if (taskType == 12) {
                  openUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                    url
                  )}`;
                }
                window.open(openUrl, "_blank");
                // 刷新页面
                window.location.reload();
              }
              break;
          }
        }

        hasTaskCompleted(id) {
          const taskDom = this.querySelector(`[data-taskId="${id}"]`);
          if (!taskDom) return;

          const completedDom = taskDom.querySelector(
            ".pq-member-tasks-btn-completed"
          );
          const btnWrapper = taskDom.querySelector(
            ".pq-member-tasks-btn-wrapper"
          );
          if (completedDom) {
            completedDom.classList.remove("hidden");
            completedDom.classList.add("flex");
          }
          if (btnWrapper) {
            btnWrapper.classList.add("hidden");
          }
        }

        async initTasks() {
          try {
            const res = await this.getMemberRedeem({
              page: 1,
              pageSize: 999,
              t: new Date().getTime(),
            });

            // 获取浏览器宽度
            const browserWidth = window.innerWidth;
            let size;
            if (browserWidth > 768 && browserWidth < 990) {
              size = 6;
            } else {
              size = 8;
            }

            const memberTasksSwiper = this.querySelector(
              ".pq-member-tasks-swiper"
            );
            const swiperWrapper =
              memberTasksSwiper.querySelector(".swiper-wrapper");
            const swiperSlides =
              memberTasksSwiper.querySelectorAll(".swiper-slide");
            const swiperSlidesCopy = swiperSlides[0]
              ? swiperSlides[0].cloneNode(true)
              : null;
            swiperWrapper.innerHTML = "";
            const slideCount = Math.ceil(res.records.length / size);

            for (let i = 0; i < slideCount; i++) {
              const swiperSlide = swiperSlidesCopy.cloneNode(true);
              const slideWrapper = swiperSlide.querySelector(".slide_wrapper");
              const slideItemCopy = slideWrapper.querySelector(".slide_item");
              const slideItemTemplate = slideItemCopy
                ? slideItemCopy.cloneNode(true)
                : null;
              slideWrapper.innerHTML = "";

              const startIndex = i * size;
              const endIndex = Math.min(startIndex + size, res.records.length);

              for (let j = startIndex; j < endIndex; j++) {
                const item = res.records[j];
                if (!item) {
                  continue;
                }

                const slideItem = slideItemTemplate.cloneNode(true);
                slideItem.setAttribute("data-taskType", item?.taskType || "");
                slideItem.setAttribute("data-taskId", item.id);

                const img = slideItem.querySelector(".pq-member-tasks-img");
                if (img) {
                  img.setAttribute("src", item.icon);
                }

                const title = slideItem.querySelector(".pq-member-tasks-title");
                if (title) {
                  title.textContent = item.taskName;
                }

                const pointsEl = slideItem.querySelector(
                  ".pq-member-tasks-points"
                );
                if (pointsEl) {
                  if (item.taskType === 4) {
                    const pointPerDollar = pointsEl.getAttribute("data-type-4");
                    pointsEl.innerHTML = pointPerDollar
                      .replace("{{ points }}", item.point * item.multiple)
                      .replace("{{ dollar }}", item.ext.amountRange);
                  } else if (item.taskType === 17) {
                    if (item.point == 0) {
                      pointsEl.textContent = item.taskDesc || "";
                    } else {
                      pointsEl.textContent = item.point;
                    }
                  } else {
                    const span = pointsEl.querySelector("span");
                    if (span) {
                      span.textContent = item.point;
                    }
                  }
                }

                const tagsEl = slideItem.querySelector(".pq-member-tasks-tags");
                if (tagsEl) {
                  if (item.tag) {
                    tagsEl.classList.remove("hidden");
                    tagsEl.textContent = item.tag;
                  } else {
                    tagsEl.classList.add("hidden");
                  }
                }

                const btnWrapper = slideItem.querySelector(
                  ".pq-member-tasks-btn-wrapper"
                );
                const btnCompleted = slideItem.querySelector(
                  ".pq-member-tasks-btn-completed"
                );
                if (item.isCompleted) {
                  if (btnWrapper) {
                    btnWrapper.classList.add("hidden");
                  }
                  if (btnCompleted) {
                    btnCompleted.classList.remove("hidden");
                    btnCompleted.classList.add("flex");
                  }
                } else {
                  if (btnWrapper) {
                    btnWrapper.classList.remove("hidden");
                  }
                  if (btnCompleted) {
                    btnCompleted.classList.add("hidden");
                  }
                }

                const btn = slideItem.querySelector(".pq-member-tasks-btn");
                if (btn) {
                  btn.addEventListener("click", () => {
                    if (window.customer) {
                      if (
                        item?.ext?.shareLinkUrl ||
                        item?.ext?.socialMediaLink
                      ) {
                        this.doTask(
                          item.id,
                          item.taskType,
                          item?.ext?.shareLinkUrl || item?.ext?.socialMediaLink
                        );
                      } else {
                        this.doTask(item.id, item.taskType);
                      }
                    } else {
                      if (item.taskType === 1) {
                        window.pq.openAccountDrawer(
                          "login-register",
                          "register"
                        );
                      } else {
                        window.pq.openAccountDrawer("login-register", "login");
                      }
                    }
                  });
                }

                slideWrapper.appendChild(slideItem);
              }
              swiperWrapper.appendChild(swiperSlide);
            }

            swiperWrapper.classList.add("flex");
            swiperWrapper.classList.remove("hidden");

            const swiperBtns = memberTasksSwiper.querySelector(
              ".pq-member-tasks-swiper-btns"
            );
            if (res.records.length <= 8) {
              if (swiperBtns) {
                swiperBtns.classList.add("hidden");
              }
            } else {
              if (swiperBtns) {
                swiperBtns.classList.remove("hidden");
              }
            }

            const emptyEl = this.querySelector(".pq-member-task-empty");
            if (res.records.length === 0) {
              if (emptyEl) {
                emptyEl.classList.remove("hidden");
              }
            }

            this.init();
          } catch (error) {
            if (window.pq?.showToast) {
              window.pqToast.showToast("error", error.message);
            }
            const memberTaskEmpty = this.querySelector(".pq-member-task-empty");
            if (memberTaskEmpty) {
              memberTaskEmpty.classList.remove("hidden");
            }
          }
        }

        init() {
          const memberTasksSwiper = this.querySelector(
            ".pq-member-tasks-swiper"
          );
          const memberTasksPrev = this.querySelector(".pq-member-tasks_prev");
          const memberTasksNext = this.querySelector(".pq-member-tasks_next");
          const scrollbarDom = this.querySelector(
            ".pq-member-tasks-swiper-scrollbar"
          );
          new Swiper(memberTasksSwiper, {
            slidesPerGroup: 1,
            slidesPerView: 1,
            spaceBetween: 24,
            navigation: {
              prevEl: memberTasksPrev,
              nextEl: memberTasksNext,
            },
            scrollbar: {
              el: scrollbarDom,
              draggable: true,
            },
          });
        }
      }
    );
  }
});
